import React, { useEffect, useState } from "react";
import { FlagLabels, JournalEntry, NoAssessments } from "./FlaggedJournals";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { CBadge } from "@coreui/react";
import moment from "moment";
import { useSelector } from "react-redux";

const Tab = ({ text, callBack, active, count = "" }) => {
  return (
    <div onClick={callBack} className={`hsc-tab${active ? "-selected" : ""}`}>
      {text}
      <CBadge
        style={{
          color: "white",
          backgroundColor: "#2bc2f7",
          marginLeft: "5px",
          padding: "5px 7px",
        }}
        shape="rounded-circle"
      >
        {count}
      </CBadge>
    </div>
  );
};

const HorizontalSwitcherComponent = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="container-fluid" style={{ margin: "0px", padding: "0px" }}>
      <div className="d-flex" style={{ marginBottom: "-25px" }}>
        <Tab
          text={"All Journals"}
          callBack={() => {
            setCurrentTab(1);
          }}
          active={currentTab === 1}
        />
        {/* <Tab
          text={"Flagged Journals"}
          callBack={() => {
            setCurrentTab(2);
          }}
          count={""}
          active={currentTab === 2}
        /> */}
      </div>
    </div>
  );
};

const Journals = (props) => {
  const [currentTab, setCurrentTab] = useState(1);
  const [selectedJournal, setSelectedJournal] = useState(null);
  const [data, setData] = useState([]);
  const { assessmentsData } = useSelector((state) => state.assessment);

  useEffect(() => {
    if (assessmentsData?.journal?.length > 0) {
      setData(assessmentsData?.journal);
    }
  }, [assessmentsData]);

  function filterData(filter) {
    switch (filter.value) {
      case "week":
        return assessmentsData?.journal?.filter((item) => {
          const date = new Date(item?.created);
          const startOfWeek = new Date();
          startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
          return date >= startOfWeek;
        });
      case "pastweek":
        return assessmentsData?.journal?.filter((item) => {
          const date = new Date(item?.created);
          const pastWeek = new Date();
          pastWeek.setDate(pastWeek.getDate() - 7);
          return date >= pastWeek;
        });
      case "2week":
        return assessmentsData?.journal?.filter((item) => {
          const date = new Date(item?.created);
          const twoWeeksAgo = new Date();
          twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
          return date >= twoWeeksAgo;
        });
      case "month":
        return assessmentsData?.journal?.filter((item) => {
          const date = new Date(item?.created);
          const startOfMonth = new Date();
          startOfMonth.setDate(1);
          return date >= startOfMonth;
        });
      case "3months":
        return assessmentsData?.journal?.filter((item) => {
          const date = new Date(item?.created);
          const threeMonthsAgo = new Date();
          threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
          return date >= threeMonthsAgo;
        });
      case "6months":
        return assessmentsData?.journal?.filter((item) => {
          const date = new Date(item?.created);
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return date >= sixMonthsAgo;
        });
      default:
        return assessmentsData?.journal;
    }
  }

  useEffect(() => {
    const sdata = filterData(props?.journalFilterValue);
    setData(sdata);
  }, [props?.journalFilterValue]);

  return (
    <div
      className="container-fluid row"
      style={{ margin: "0px", padding: "0px" }}
    >
      <CardLayout
        className="col-sm-12 col-md-5 col-lg-5"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
          height: "100vh",
        }}
      >
        <HorizontalSwitcherComponent
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />

        <div style={{ height: "100%", overflowY: "scroll", width: "100%" }}>
          {console.log("data",data)}
          {data.length > 0 &&
            data
              .filter((item) => {
                if (
                  item?.nlp_results?.length > 0 ||
                  !item?.entry?.includes("created on basis of ")
                ) {
                  return item;
                }
              })
              .sort((a, b) => {
                const dateA = new Date(a?.created);
                const dateB = new Date(b?.created);
                return dateB - dateA; 
              })
              .map((entry) => {
                return (
                  <div className="py-1" key={entry.id}>
                    <JournalEntry
                      date={entry.modified}
                      text={entry.entry}
                      labels={
                        entry.nlp_results.length > 0
                          ? entry.nlp_results.map((item) => {
                              return item?.predicted_label || "";
                            })
                          : []
                      }
                      entry={entry}
                      isSelected={
                        entry.id === (selectedJournal && selectedJournal.id) ||
                        false
                      }
                      setSelectedJournal={(entry) => {
                        setSelectedJournal(null);
                        setSelectedJournal(entry);
                      }}
                      isClickable={true}
                      lablesPosition="bottom"
                    />
                  </div>
                );
              })}
          {data.length < 1 && (
            <NoAssessments
              text="There are no journals to show!"
              show_link={false}
            />
          )}
        </div>
      </CardLayout>
      <CardLayout
        className="col-sm-12 col-md-7 col-lg-7"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        {selectedJournal && (
          <div className="container-fluid p-3">
            <div className="d-flex justify-content-between">
              <label
                className="primary-text-blue"
                style={{ fontSize: "1.3rem" }}
              >
                {moment(selectedJournal.modified).format("MMM DD, YYYY")}
              </label>
              <button
                onClick={() => {
                  setSelectedJournal(null);
                }}
                className="transparent-btn"
              >
                <CloseIcon />
              </button>
            </div>
            <div className="my-3" style={{ display: "block", width: "25%" }}>
              {selectedJournal?.nlp_results.length > 0 &&
                selectedJournal?.nlp_results.map((item, index) => {
                  return (
                    <FlagLabels key={index} label={item?.predicted_label} />
                  );
                })}
            </div>
            <div
              className="container-fluid"
              style={{ margin: "0px", padding: "0px" }}
            >
              <textarea
                className="entry-textarea"
                readOnly
                style={{ height: "70vh" }}
                value={selectedJournal?.entry}
              />
              <div className="d-flex justify-content-center">
                <hr
                  style={{
                    width: "90%",
                    backgroundColor: "rgba(154, 197, 239, 0.23)",
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {!selectedJournal && (
          <NoAssessments text={"No Journal Selected"} link="" link_text="" />
        )}
      </CardLayout>
    </div>
  );
};

export default Journals;
